<template>
  <GbwapsLayout title="GB WhatsApp Update Guide 2026" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="update-page">
      <div class="warning-box update-backup-warning">
        <strong>Backup first:</strong>
        Run Chat backup before any update. Installing over the old app usually keeps data, but a fresh backup is your
        safety net if signatures mismatch.
      </div>

      <PageChecklist title="Update checklist" :items="checklist" class="mb-24" />

      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <ol v-if="section.layout === 'timeline'" class="update-timeline">
          <li v-for="item in timeline" :key="item.step" class="update-timeline-item">
            <span class="update-timeline-marker">{{ item.step }}</span>
            <div class="update-timeline-body">
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </div>
          </li>
        </ol>

        <PageChecklist v-if="section.layout === 'checklist'" title="Backup checklist" :items="checklist" />
      </section>

      <p class="text-center mt-24">
        <router-link to="/download/" class="btn-primary">Download Latest GB WhatsApp APK</router-link>
      </p>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import PageChecklist from '@/components/gbwaps/PageChecklist.vue';
import { UPDATE_CHECKLIST, UPDATE_TIMELINE, UPDATE_SECTIONS } from '@/data/update-content';

export default {
  name: 'GbwhatsappUpdatePage',
  components: { GbwapsLayout, ContentBlocks, PageChecklist },
  data() {
    return {
      pageIntro:
        'Update GB WhatsApp to v18.80 without losing chats: backup, download, install over the top, and fix common errors.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Update' }],
      checklist: UPDATE_CHECKLIST,
      timeline: UPDATE_TIMELINE,
      sections: UPDATE_SECTIONS,
    };
  },
};
</script>
